import React from 'react'
import { PALETTE } from '../../styles/constants'

function ChevronDownIconSelect({ color = PALETTE.gray80, width = 24, height = 24 }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill="none">
      <g clipPath="url(#clip0_1957_4725)">
        <path d="M12 16.5L4.5 9L5.55 7.95L12 14.4L18.45 7.95L19.5 9L12 16.5Z" fill={color}/>
      </g>
      <defs>
        <clipPath id="clip0_1957_4725">
          <rect width={width} height={height} fill="white"/>
        </clipPath>
      </defs>
    </svg>
  )
}

export default ChevronDownIconSelect
